import { HiUserCircle, HiCalendar, HiUserGroup, HiHome } from 'react-icons/hi';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DnsIcon from '@mui/icons-material/Dns';
import SupportIcon from '@mui/icons-material/Support';
import SettingsIcon from '@mui/icons-material/Settings';
import { RoutePermittedRole } from 'shared/constants/AppConst';
import LanIcon from '@mui/icons-material/Lan';
import PeopleIcon from '@mui/icons-material/People';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BusinessIcon from '@mui/icons-material/Business';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SellIcon from '@mui/icons-material/Sell';
import CommuteIcon from '@mui/icons-material/Commute';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import RateReviewIcon from '@mui/icons-material/RateReview';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import FestivalIcon from '@mui/icons-material/Festival';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import FeedIcon from '@mui/icons-material/Feed';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import StyleIcon from '@mui/icons-material/Style';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import AddTaskIcon from '@mui/icons-material/AddTask';
import BillIcon from "../assets/icon/Billing-Module-Icons/sidemenu/billing-mpdule.svg";
// TEMPORARY — remove this import with the FairCabSimulator feature
import ScienceIcon from '@mui/icons-material/Science';
import IncompleteTripIcon from "../assets/icon/Billing-Module-Icons/sidemenu/Incomplte_Trips.svg";
import ManageDutiesIcon from "../assets/icon/Billing-Module-Icons/sidemenu/manage-duties.svg";
import IssueBucketsIcon from "../assets/icon/Billing-Module-Icons/sidemenu/Issue.svg";
import CustomReportsIcon from "../assets/icon/Billing-Module-Icons/customReports.svg";

const routesConfig = [
  {
    id: 'home',
    title: 'Home',
    messageId: 'Home',
    permittedRole: RoutePermittedRole.ALL,
    icon: <HiHome />,
    type: 'item',
    url: '/dashboard',
  },
  {
    id: 'taxes',
    title: 'Taxes',
    messageId: 'Taxes',
    module: 'Taxes',
    submodule: 'Taxes',
    iconUrl: 'Taxes',
    permittedRole: RoutePermittedRole.ALL,
    icon: <HiUserCircle />,
    type: 'item',
    url: '/taxes',
  },
  {
    id: 'manageThemess',
    title: 'Manage Themes',
    messageId: 'Themes',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/themes',
    icon: <ColorLensIcon sx={{ fontSize: '20px' }} />,
  },
  {
    id: 'manageusers',
    title: 'Manage Users',
    messageId: 'Users',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/users',
    icon: <HiUserCircle />,
  },
  {
    id: 'manageRoles',
    title: 'Manage Roles',
    module: 'Manage Roles',
    submodule: 'Manage Roles',
    messageId: 'Roles',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/roles',
    icon: <SupervisedUserCircleIcon sx={{ fontSize: '22px' }} />,
  },
  {
    id: 'customerpage',
    title: 'customerpage',
    messageId: 'Customers ',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/customers',
    icon: <HomeWorkIcon sx={{ fontSize: 'large' }} />,
  },
  {
    id: 'MasterSupport',
    title: 'Support Master',
    messageId: 'Support Master',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'collapse',
    iconUrl: '',
    icon: <SupportAgentIcon sx={{ fontSize: 'large' }} />,
    children: [
      {
        id: 'topics',
        title: 'Topics',
        messageId: 'Topics',
        permittedRole: RoutePermittedRole.superAdmin,
        type: 'item',
        url: '/Master/support/topic-list',
        icon: <SupervisorAccountIcon />,
      },
      {
        id: 'faqs',
        title: 'FAQs',
        messageId: 'FAQs',
        permittedRole: RoutePermittedRole.superAdmin,
        type: 'item',
        url: '/Master/support/faq-list',
        icon: <ContactSupportIcon sx={{ fontSize: '22px' }} />,
      },
    ],
  },
  {
    id: 'VehicleMaster',
    title: 'Vehicle Master',
    messageId: 'Vehicle Master',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'collapse',
    iconUrl: '',
    icon: <DriveEtaIcon sx={{ fontSize: '22px' }} />,
    children: [
      {
        id: 'vehicleColorTheme',
        title: 'Vehicle Color Theme',
        messageId: 'Vehicle Color Theme',
        permittedRole: RoutePermittedRole.superAdmin,
        type: 'item',
        url: '/vehicle-color',
        icon: <StyleIcon sx={{ fontSize: '22px' }} />,
      },
      {
        id: 'vehicleType',
        title: 'Vehicle Type',
        messageId: 'Vehicle Type',
        permittedRole: RoutePermittedRole.superAdmin,
        type: 'item',
        url: '/vehicle-master',
        icon: <AirportShuttleIcon sx={{ fontSize: '22px' }} />,
      },
      {
        id: 'vehicleModel',
        title: 'Vehicle Model',
        messageId: 'Vehicle Model',
        permittedRole: RoutePermittedRole.superAdmin,
        type: 'item',
        url: '/vehicle-model',
        icon: <LocalTaxiIcon sx={{ fontSize: '22px' }} />,
      },
    ],
  },
  {
    id: 'Compliances',
    title: 'Add Compliances',
    messageId: 'Compliance Master',
    iconUrl: 'Compliance',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/master/compliance/list',
    icon: <RuleFolderIcon />,
  },
  {
    id: 'FeedbackMaster',
    title: 'Feedbacks',
    messageId: 'Feedbacks',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/feedbacks',
    icon: <FeedIcon sx={{ medium: '22px' }} />,
  },
  {
    id: 'taxCategory',
    title: 'Tax Category',
    messageId: 'Tax ',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/tax-categories',
    icon: <PriceChangeIcon sx={{ medium: '22px' }} />,
  },
  {
    id: 'fuelPrice',
    title: 'Fuel Price',
    messageId: 'Fuel Price ',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/fuel-price',
    icon: <LocalGasStationIcon sx={{ fontSize: '22px' }} />,
  },
  {
    id: 'managetraining',
    title: 'Training Video',
    messageId: 'Self Help',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/training-video',
    icon: <OndemandVideoIcon sx={{ fontSize: '21px' }} />,
  },
  {
    id: 'managegpsvendor',
    title: 'GPS Vendor',
    messageId: 'GPS Vendor',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/Mastergps',
    icon: <FestivalIcon sx={{ fontSize: '21px' }} />,
  },
  {
    id: 'manageassociation',
    title: 'Manage Association',
    messageId: 'Association',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/association',
    icon: <AddTaskIcon sx={{ fontSize: 'medium' }} />,
  },
  {
    id: 'onboardCorporates',
    title: 'Manage Corporates',
    permittedRole: [
      RoutePermittedRole.tenentAdmin,
      RoutePermittedRole.superAdmin,
    ],
    messageId: 'Manage Corporates',
    type: 'item',
    icon: <HiUserGroup />,
    url: '/onboard-corporate/list',
  },
  {
    id: 'LiveTrip',
    title: 'LiveTrip',
    module: 'Active Trips',
    submodule: 'Active Trips',
    iconUrl: 'ActiveTrip',
    messageId: 'Active Trips',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/onboard-corporate/livetrip',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
  },
  {
    id: 'LiveTracking',
    title: 'Live Tracking',
    module: 'Live Tracking',
    submodule: 'Live Tracking',
    messageId: 'Live Tracking',
    iconUrl: 'LiveTracking',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
    url: '/live-tracking-dashboard/default',
  },
  {
    id: 'YourRides',
    title: 'Your Rides',
    module: 'Your Rides',
    submodule: 'Your Rides',
    messageId: 'Your Rides',
    iconUrl: 'YourRides',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
    url: '/your-ride',
  },
  {
    id: 'Master',
    title: 'Master',
    module: 'Master',
    messageId: 'Master',
    permittedRole: RoutePermittedRole.ALL,
    type: 'collapse',
    iconUrl: 'Master',
    icon: <DnsIcon fontSize='small' />,
    children: [
      {
        id: 'employees',
        title: 'Register Employee Table',
        module: 'Master',
        submodule: 'Employees',
        messageId: 'Employees',
        iconUrl: 'Employees',
        permittedRole: [RoutePermittedRole.ALL],
        type: 'item',
        icon: <HiUserCircle />,
        url: '/onboardCorporate/employee/employee-listing',
      },
      {
        id: 'CreateShifts',
        title: 'Register Shifts Details',
        module: 'Master',
        iconUrl: 'Shifts',
        submodule: 'Shifts',
        messageId: 'Shifts',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/onboard-corporate/shift/list',
        icon: <ScheduleIcon fontSize='small' />,
      },
      {
        id: 'createDepartment',
        title: 'Our Department',
        module: 'Master',
        submodule: 'Departments',
        iconUrl: 'Departments',
        messageId: 'Departments',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/onboard-corporate/department/list',
        icon: <LanIcon fontSize='small' />,
      },
      {
        id: 'createbusinessunit',
        title: 'Business Unit',
        module: 'Master',
        iconUrl: 'BusinessUnits',
        submodule: 'Business Unit',
        messageId: 'Business Unit',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/onboard-tenant/bussiness-unit/table',
        icon: <BusinessIcon fontSize='small' />,
      },
      {
        id: 'vendorList',
        title: 'Vendors Listing',
        module: 'Master',
        submodule: 'Vendors',
        iconUrl: 'Vendors',
        messageId: 'Vendors',
        permittedRole: RoutePermittedRole.ALL,
        icon: <StorefrontIcon fontSize='small' />,
        type: 'item',
        url: '/onboardadmin/vendor/vendor-listing/Def',
      },
      {
        id: 'driversList',
        title: 'Drivers Listing',
        module: 'Master',
        submodule: 'Drivers',
        iconUrl: 'Drivers',
        messageId: 'Drivers',
        permittedRole: RoutePermittedRole.ALL,
        icon: (
          <img className='sidebar-icon' src={'/assets/images/driver.svg'} />
        ),
        hoverIcon: (
          <img className='sidebar-icon' src={'/assets/images/driver-2.svg'} />
        ),
        type: 'item',
        url: '/onboardadmin/driver/driver-listing/Def',
      },
      {
        id: 'vehicleList',
        title: 'Vehicles Listing',
        module: 'Master',
        submodule: 'Vehicles',
        messageId: 'Vehicles',
        iconUrl: 'Vehicle',
        permittedRole: RoutePermittedRole.ALL,
        icon: <DriveEtaIcon />,
        type: 'item',
        url: '/onboardadmin/vehicle/vehicle-listing/Def',
      },
      {
        id: 'vehicleDriverMapping',
        title: 'Vehicle Driver GPS Mapping',
        module: 'Master',
        submodule: 'Vehicle Driver GPS Mapping',
        messageId: 'Vehicle Driver GPS Mapping',
        iconUrl: 'Vehicle',
        permittedRole: RoutePermittedRole.ALL,
        icon: <DriveEtaIcon />,
        type: 'item',
        url: '/onboardadmin/vehicle/vehicle-driver-gps-mapping',
      },
      {
        id: 'manageHoliday',
        title: 'Manage Holiday',
        module: 'Master',
        submodule: 'Manage Holidays',
        iconUrl: 'Holidays',
        messageId: 'Manage Holidays',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/onboard-corporate/holiday/list',
        icon: <CalendarTodayIcon fontSize='small' />,
      },
      {
        id: 'Trip',
        title: 'Register Nodal Point Detail',
        module: 'Master',
        submodule: 'Nodal Point',
        messageId: 'Nodal Point',
        iconUrl: 'NodalPoints',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/onboard-tenant/nodal-point/table',
        icon: <AddLocationAltIcon style={{ fontSize: 'large' }} />,
      },
      {
        id: 'routingSchema',
        title: 'Routing Schema',
        module: 'Master',
        submodule: 'Routing Schema',
        messageId: 'Routing Schema',
        iconUrl: 'RoutingRule',
        icon: <span />,
        permittedRole: [RoutePermittedRole.superAdmin, RoutePermittedRole.corporateAdmin, RoutePermittedRole.tenentAdmin],
        type: 'item',
        url: '/master/routing-schema',
      },
      {
        id: 'vendorContract',
        title: 'Vendor Allocation Contract',
        module: 'Master',
        iconUrl: 'Vendors',
        submodule: 'Vendor Allocation Contract',
        messageId: 'Vendor Allocation Contract',
        permittedRole: [RoutePermittedRole.superAdmin, RoutePermittedRole.corporateAdmin, RoutePermittedRole.tenentAdmin],
        type: 'item',
        url: '/onboard-corporate/vendor-contract/list',
        icon: <StorefrontIcon fontSize='small' />,
      },
      {
        id: 'employeeCategory',
        title: 'Employee Category',
        module: 'Master',
        iconUrl: 'EmployeeCategory',
        submodule: 'Employee Category',
        messageId: 'Employee Category',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/onboard-corporate/employee-category/table',
        icon: <PeopleIcon fontSize='small' />,
      },
      {
        id: 'escort',
        title: 'Escort List',
        module: 'Master',
        iconUrl: 'Escorts',
        submodule: 'Escort',
        messageId: 'Escort',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: (
          <img className='sidebar-icon' src={'/assets/images/escort.svg'} />
        ),
        url: '/onboardadmin/escort/escort-listing',
      },
      {
        id: 'escortAgency',
        title: 'Escort Agency List',
        module: 'Master',
        submodule: 'Escort Agency',
        iconUrl: 'EscortAgency',
        messageId: 'Escort Agency',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: (
          <img className='sidebar-icon' src={'/assets/images/escort.svg'} />
        ),
        url: '/onboard-corporate/escort-agency/list',
      },
      {
        id: 'siteOfficeList',
        title: 'SiteOffice Listing',
        module: 'Master',
        submodule: 'Site Office',
        iconUrl: 'SiteOffice',
        messageId: 'Site Office',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <BusinessIcon style={{ fontSize: 'large' }} />,
        url: '/onboard-corporate/site-office/listing',
      },
      {
        id: 'specialEmployee',
        title: 'Special Employee Table',
        messageId: 'Special Employee',
        module: 'Master',
        iconUrl: 'SpecialEmployee',
        submodule: 'Special Employee',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: (
          <img
            className='sidebar-icon'
            src={'/assets/images/specialEmployee.svg'}
          />
        ),
        url: '/onboard-corporate/special-employee/listing',
      },
      {
        id: 'penlty',
        title: 'Penalty',
        messageId: 'Penalty ',
        module: 'Master',
        submodule: 'Penalty',
        iconUrl: 'Penalty',
        permittedRole: RoutePermittedRole.ALL,
        icon: (
          <img className='sidebar-icon' src={'/assets/images/penality.svg'} />
        ),
        type: 'item',
        url: '/onboard-corporate/penalty/listing',
      },
      {
        id: 'RegisterVehicle',
        title: 'Register Vehicle Table',
        messageId: 'Vehicle Variant ',
        module: 'Master',
        iconUrl: 'VehicleVariant',
        submodule: 'Vehicle Variant',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <CommuteIcon fontSize='small' />,
        url: '/Master/vehicleType/table',
      },
      {
        id: 'GpsList',
        title: 'GPS List',
        messageId: 'GPS List',
        module: 'Master',
        iconUrl: 'GpsLists',
        submodule: 'GPS List',
        permittedRole: RoutePermittedRole.superAdmin,
        type: 'item',
        icon: (
          <img
            className='sidebar-icon'
            src={'/assets/images/liveLocation.svg'}
          />
        ),
        url: '/Master/Gps-list/list',
      },
      {
        id: 'corporateFuelPrice',
        title: 'Fuel Price',
        module: 'Master',
        submodule: 'Fuel Price',
        messageId: 'Fuel Price',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <LocalGasStationIcon sx={{ fontSize: '22px' }} />,
        url: '/master/corporate-fuel-price',
      },
      {
        id: 'cabId',
        title: 'Cab ID',
        messageId: 'Cab ID',
        module: 'Master',
        submodule: 'Cab ID',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <DriveEtaIcon fontSize='small' />,
        url: '/onboard-corporate/cab-id/list',
      },
      {
        id: 'parkingZone',
        title: 'Parking Zone',
        messageId: 'Parking Zone',
        module: 'Master',
        submodule: 'Parking Zone',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <LocalParkingIcon fontSize='small' />,
        url: '/parking-management/parking-zone',
      },
      {
        id: 'parkingSlot',
        title: 'Parking Slot',
        messageId: 'Parking Slot',
        module: 'Master',
        submodule: 'Parking Slot',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <LocalParkingIcon fontSize='small' />,
        url: '/parking-management/parking-slot',
      },
    ],
  },
  {
    id: 'roster',
    title: 'Roster',
    messageId: 'Schedule Management',
    module: 'RosterManager',
    submodule: 'RosterManager',
    iconUrl: 'Roster',
    permittedRole: RoutePermittedRole.ALL,
    icon: (
      <img className='sidebar-icon' src={'/assets/images/rosterIcon.png'} />
    ),
    type: 'item',
    url: '/rosters/roster-creation',
  },
  {
    id: 'AdhocTrips',
    title: 'AdhocTrip',
    messageId: 'Adhoc Trip Management',
    module: 'Adhoc TripManager',
    submodule: 'Adhoc TripManager',
    iconUrl: 'Adhoc',
    permittedRole: RoutePermittedRole.ALL,
    icon: <DriveEtaIcon style={{ color: 'white' }} />,
    type: 'item',
    url: '/pending-adhoc-trip',
  },
  {
    id: 'Leave',
    title: 'Manage Leaves',
    messageId: 'Manage Leaves',
    module: 'Manage Leaves',
    submodule: 'Manage Leaves',
    iconUrl: 'Leave',
    permittedRole: RoutePermittedRole.ALL,
    icon: <ManageAccountsIcon fontSize='small' />,
    type: 'item',
    url: '/leave-listing',
  },
  {
    id: 'adhocTrip',
    title: 'adhocTrip',
    messageId: 'Adhoc Trip',
    module: 'Adhoc TripEmployee',
    submodule: 'Adhoc TripEmployee',
    iconUrl: 'Adhoc',
    permittedRole: RoutePermittedRole.ALL,
    icon: <ManageAccountsIcon fontSize='small' />,
    type: 'item',
    url: '/adhoc-trip-list',
  },
  {
    id: 'rosterEmployee',
    title: 'Roster',
    messageId: 'Schedule',
    module: 'RosterEmployee',
    submodule: 'RosterEmployee',
    iconUrl: 'Roster',
    permittedRole: RoutePermittedRole.ALL,
    url: '/rosters/my-roster-request',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/rosterIcon.png'} />
    ),
    type: 'item',
  },
  {
    id: 'Triprequest',
    title: 'Roster',
    module: 'Roster',
    submodule: 'Roster',
    iconUrl: 'Roster',
    messageId: 'Schedule',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/rosters/roster-page',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/rosterIcon.png'} />
    ),
    icon2: <img className='sidebar-icon' src={'/assets/images/yesIcon.png'} />,
  },
  {
    id: 'routeListss',
    title: 'Route List',
    messageId: 'Route List (Vendor)',
    module: 'RoutesVendor',
    submodule: 'RoutesVendor',
    iconUrl: 'Routes',
    permittedRole: RoutePermittedRole.ALL,
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
    type: 'item',
    url: '/route-lists-for-vendor/ALL',
  },
  {
    id: 'driverAttendance',
    title: 'Roster',
    module: 'Driver Attendance',
    submodule: 'Driver Attendance',
    iconUrl: 'Roster',
    messageId: 'Driver Attendance',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/driver-attendance',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/rosterIcon.png'} />
    ),
    icon2: <img className='sidebar-icon' src={'/assets/images/yesIcon.png'} />,
  },
  {
    id: 'routes',
    title: 'Routes',
    module: 'Routes',
    messageId: 'Routes',
    iconUrl: 'Routes',
    permittedRole: RoutePermittedRole.ALL,
    type: 'collapse',
    icon: <img className='sidebar-icon' src={'/assets/images/routeIcon.svg'} />,
    children: [
      {
        id: 'createMasterRoutes',
        title: 'Route Master',
        module: 'Route Master',
        submodule: 'Route Master',
        messageId: 'Route Master',
        iconUrl: 'RouteMaster',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/master-routes',
        icon: (
          <img
            className='sidebar-icon'
            src={'/assets/images/routeMaster.svg'}
          />
        ),
      },
      {
        id: 'shuttleMasters',
        title: 'Shuttle Masters',
        module: 'Master',
        submodule: 'Shuttle Masters',
        messageId: 'Shuttle Masters',
        iconUrl: 'Shuttle Masters',
        permittedRole: [RoutePermittedRole.ALL],
        type: 'item',
        icon: <AirportShuttleIcon sx={{ fontSize: '22px' }} />,
        url: '/shuttle/masters',
      },
      {
        id: 'routeList',
        title: 'Auto Generated',
        module: 'Auto Generated',
        submodule: 'Auto Generated',
        messageId: 'Auto Generated',
        iconUrl: 'VRP',
        permittedRole: RoutePermittedRole.ALL,
        icon: (
          <img className='sidebar-icon' src={'/assets/images/routeList.svg'} />
        ),
        type: 'item',
        url: '/create-new-route',
      },
      {
        id: 'routeLists1',
        title: 'Route List',
        module: 'Route List',
        submodule: 'Route List',
        iconUrl: 'RouteList',
        messageId: 'Route List',
        permittedRole: RoutePermittedRole.ALL,
        icon: (
          <img className='sidebar-icon' src={'/assets/images/routeList.svg'} />
        ),
        type: 'item',
        url: '/route-lists/ALL',
      },
    ],
  },
  {
    id: 'AdhocTripss',
    title: 'AdhocTrip',
    module: 'Adhoc Trip',
    submodule: 'Adhoc Trip',
    messageId: 'Adhoc Trip',
    permittedRole: RoutePermittedRole.ALL,
    iconUrl: 'Adhoc',
    type: 'item',
    url: '/create-form/corporate-adhoc-trip',
    icon: <DriveEtaIcon style={{ color: 'white' }} />,
  },
  {
    id: 'LeaveManagement',
    title: 'Leave',
    messageId: 'Leave Management',
    module: 'Leave Management',
    iconUrl: 'Leave',
    submodule: 'Leave Management',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    icon: <ManageAccountsIcon fontSize='small' />,
    url: '/all-leave-listing',
  },
  {
    id: 'compliances',
    title: 'Compliance',
    messageId: 'Compliance',
    module: 'Compliance',
    iconUrl: 'Compliance',
    submodule: 'Compliance',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    icon: <AdminPanelSettingsIcon fontSize='small' />,
    url: '/compliance-listing',
  },
  {
    id: 'fuelTracking',
    title: 'Fuel Tracking',
    module: 'Fuel Tracking',
    submodule: 'Fuel Tracking',
    iconUrl: 'FuelTracking',
    messageId: 'Fuel Tracking',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/fuel-track',
    icon: <ManageAccountsIcon fontSize='small' />,
  },
  {
    id: 'reports',
    title: 'Reports',
    module: 'Reports',
    submodule: 'Reports',
    iconUrl: 'Reports',
    messageId: 'Reports',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/master/reports',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
  },
  {
    id: 'tripReports',
    title: 'Trip Report',
    module: 'Trip Report',
    submodule: 'Trip Report',
    iconUrl: 'Reports',
    messageId: 'Trip Reports',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/trip-history',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
  },
  {
    id: 'auditTrail',
    title: 'Audit Trail',
    module: 'Audit Trail',
    submodule: 'Audit Trail',
    iconUrl: 'Reports',
    messageId: 'Audit Trail',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/audit-trail',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
  },
  {
    id: 'tripSummary',
    title: 'Trip Summary',
    module: 'Trip Summary',
    submodule: 'Trip Summary',
    iconUrl: 'Reports',
    messageId: 'Trip Summary',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/trip-summary',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
  },
  {
    id: 'driverBenefits',
    title: 'Driver Benefits',
    module: 'Driver Benefits',
    submodule: 'Driver Benefits',
    iconUrl: 'Reports',
    messageId: 'Driver Benefits',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/driver-benefit',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
  },
  // {
  //   id: 'CorpBilling',
  //   title: "Corporate's Billing",
  //   messageId: "Corporate's Billing",
  //   module: 'Corporates Billing',
  //   submodule: 'Corporates Billing',
  //   iconUrl: 'CorpBilling',
  //   permittedRole: RoutePermittedRole.ALL,
  //   icon: (
  //     <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
  //   ),
  //   type: 'item',
  //   url: '/vendor-billings',
  // },
  {
    id: 'Billing',
    title: 'Billing',
    module: 'Billing-archive',
    submodule: 'Billing',
    messageId: 'Billing',
    iconUrl: 'Billing',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/billings',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
  },
  {
    id: 'Billing Module',
    title: 'Billing Module',
    messageId: 'Billing Module',
    module: 'Billing',
    permittedRole: RoutePermittedRole.ALL,
    type: 'collapse',
    icon: (
      <img className='sidebar-icon' src={BillIcon} />
    ),
    children: [
      {
        id: 'Incomplete Trips',
        title: 'Incomplete Trips',
        messageId: 'Incomplete Trips',
        module: 'Billing',
        submodule: 'Incomplete Trips',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/incomplete-trips',
        icon: (
          <img className='sidebar-icon' src={IncompleteTripIcon} />
        )
      },
      {
        id: 'Issues',
        title: 'Issues',
        messageId: 'Issues',
        module: 'Billing',
        submodule: 'Issues',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/issue-buckets',
        icon: (
          <img className='sidebar-icon' src={IssueBucketsIcon} />
        ),
      },
      {
        id: 'Billing',
        title: 'Billing',
        messageId: 'Billing',
        module: 'Billing',
        submodule: 'Billing',
        permittedRole: RoutePermittedRole.ALL,
        iconUrl: 'Billing',
        type: 'item',
        url: '/billing-reports',
        icon: <ManageAccountsIcon fontSize='small' />,
      },
      {
        id: 'Custom Report',
        title: 'Custom Report',
        messageId: 'Custom Report',
        module: 'Billing',
        submodule: 'Custom Report',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/custom-report',
        icon: (
          <img className='sidebar-icon' src={CustomReportsIcon} />
        ),
      },
      {
        id: 'Rate-Card',
        title: 'Rate Card',
        messageId: 'Rate Card',
        module: 'Billing',
        submodule: 'Rate Card',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <SellIcon fontSize='small' />,
        url: '/rate-card-list',
      },
      {
        id: 'zoneMaster',
        title: 'Zone Master',
        messageId: 'Zone Master',
        module: 'Billing',
        submodule: 'Zone Master',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: (
          <img
            className='sidebar-icon'
            src={'/assets/images/zone-master-white.svg'}
          />
        ),
        url: '/master/zone',
      },
      {
        id: 'garageMaster',
        title: 'Garage Master',
        messageId: 'Garage Master',
        module: 'Billing',
        submodule: 'Garage Master',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: (
          <img
            className='sidebar-icon'
            src={'/assets/images/garage-master-white.svg'}
          />
        ),
        url: '/master/garage',
      },
      {
        id: 'General Settings',
        title: 'General Settings',
        messageId: 'General Settings',
        module: 'Billing',
        submodule: 'General Settings',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <SettingsIcon sx={{ fontSize: '22px' }} />,
        url: '/general-settings',
      },
      {
        id: 'Billing Rules',
        title: 'Billing Rules',
        messageId: 'Billing Rules',
        module: 'Billing',
        submodule: 'Billing Rules',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <RuleFolderIcon sx={{ fontSize: '22px' }} />,
        url: '/billing-rules',
      },
    ]
  },
  {
    id: 'Duties',
    title: 'Duties',
    messageId: 'Duties',
    module: 'Duties',
    permittedRole: RoutePermittedRole.ALL,
    type: 'collapse',
    icon: (
      <img className='sidebar-icon' src={ManageDutiesIcon} />
    ),
    children: [
      {
        id: 'Manage Duties',
        title: 'Manage Duties',
        messageId: 'Manage Duties',
        module: 'Duties',
        submodule: 'Manage Duties',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: (
          <img className='sidebar-icon' src={ManageDutiesIcon} />
        ),
        url: '/manage-duties',
      },
      {
        id: 'Duty Setting',
        title: 'Duty Setting',
        messageId: 'Duty Setting',
        module: 'Duties',
        submodule: 'Duty Setting',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: <SettingsIcon sx={{ fontSize: '22px' }} />,
        url: '/duty-setting',
      },
    ],
  },
  {
    id: 'IVR',
    title: 'IVR',
    module: 'IVR',
    submodule: 'IVR',
    messageId: 'IVR',
    iconUrl: 'IVR',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/IVR',
    icon: (
      <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
    ),
  },
  // {
  //   id: 'Invoicing',
  //   title: 'Invoicing',
  //   module: 'Invoicing',
  //   submodule: 'Invoicing',
  //   messageId: 'Invoicing',
  //   iconUrl: 'Invoicing',
  //   permittedRole: RoutePermittedRole.ALL,
  //   type: 'item',
  //   url: '/invoice-listing-vendor/Today/null/null',
  //   icon: (
  //     <img className='sidebar-icon' src={'/assets/images/liveLocation.svg'} />
  //   ),
  // },
  {
    id: 'feedback',
    title: 'Feedback',
    messageId: 'Feedback',
    module: 'Feedback',
    iconUrl: 'Feedback',
    submodule: 'Feedback',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    icon: (
      <img
        className='sidebar-icon'
        src={'/assets/images/specialEmployee.svg'}
      />
    ),
    url: '/feedbacks',
    roleUrls: { CORPORATEADMIN: '/feedback-view' },
  },
  {
    id: 'driverConsent',
    title: 'driverconsent',
    messageId: 'Driver Consent',
    permittedRole: RoutePermittedRole.superAdmin,
    type: 'item',
    url: '/driver-consent',
    icon: <DocumentScannerIcon sx={{ fontSize: '22px' }} />,
  },
  {
    id: 'TrainingVideo',
    title: 'Training Video',
    messageId: 'Training Video',
    permittedRole: RoutePermittedRole.ALL,
    module: 'Training Videos',
    submodule: 'Training Videos',
    type: 'item',
    url: '/training-video',
    icon: <OndemandVideoIcon sx={{ fontSize: '21px' }} />,
  },

  {
    id: 'trainingVideo',
    title: 'TrainingVideo',
    messageId: 'Training Videos',
    iconUrl: 'Trainingvideo',
    permittedRole: RoutePermittedRole.superAdmin,
    icon: <OndemandVideoIcon sx={{ fontSize: '21px' }} />,
    url: '/training-video',
  },
  {
    id: 'announcementList',
    title: 'Announcement Listing',
    module: 'Announcements',
    submodule: 'Announcements',
    messageId: 'Announcements',
    permittedRole: RoutePermittedRole.ALL,
    iconUrl: 'Announcement',
    type: 'item',
    icon: <BusinessIcon />,
    url: '/onboard-corporate/announcement/list',
  },
  {
    id: 'support',
    title: 'Register Trip Detail',
    module: 'Support',
    submodule: 'Support',
    iconUrl: 'Support',
    messageId: 'Support',
    icon: <SupportIcon />,
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    url: '/user/support',
  },
  {
    id: 'Incident Management Type',
    title: 'Incident Management Type',
    module: 'Incident Management',
    submodule: 'Incident Management',
    messageId: 'Incident Management',
    permittedRole: RoutePermittedRole.ALL,
    type: 'item',
    icon: <SupportIcon fontSize='small' />,
    url: '/incident-view',
  },
  // // TEMPORARY — Fair Cab Allocation Simulator (hidden in production)
  // ...(process.env.REACT_APP_MODE !== 'production' ? [{
  //   id: 'fairCabSimulator',
  //   title: 'Fair Cab Allocation Simulation',
  //   messageId: 'Fair Cab Simulation',
  //   permittedRole: RoutePermittedRole.all,
  //   type: 'item',
  //   icon: <ScienceIcon sx={{ fontSize: '20px' }} />,
  //   url: '/tools/fair-cab-simulator',
  // }] : []),
  {
    id: 'Setting',
    title: 'Setting',
    messageId: 'Setting',
    module: 'Setting',
    iconUrl: 'Setting',
    permittedRole: RoutePermittedRole.ALL,
    type: 'collapse',
    icon: <SettingsIcon fontSize='small' />,
    children: [
      {
        id: 'Roster Setting',
        title: 'Roster Setting',
        messageId: 'Schedule ',
        module: 'Setting',
        submodule: 'Roster Setting',
        iconUrl: 'RosterSettings',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/roster-setting-list',
        icon: <ManageAccountsIcon fontSize='small' />,
      },
      {
        id: 'Route',
        title: 'Route',
        messageId: 'Routing Rule',
        module: 'Setting',
        submodule: 'Routing Rule',
        permittedRole: RoutePermittedRole.ALL,
        iconUrl: 'RoutingRule',
        type: 'item',
        icon: (
          <img
            className='sidebar-icon'
            src={'/assets/images/routingRules.svg'}
          />
        ),
        url: '/manage-route/routing-rule',
      },
      {
        id: 'LeaveSetting',
        title: 'Leave Setting',
        messageId: 'Leave',
        module: 'Setting',
        submodule: 'Leave Setting',
        permittedRole: RoutePermittedRole.ALL,
        iconUrl: 'LeaveSetting',
        type: 'item',
        url: '/leave-settings',
        icon: <ManageAccountsIcon fontSize='small' />,
      },
      {
        id: 'SOS Setting',
        title: 'SOS Setting',
        messageId: 'SOS',
        module: 'Setting',
        submodule: 'SOS Setting',
        permittedRole: RoutePermittedRole.ALL,
        iconUrl: 'SOSSettings',
        type: 'item',
        url: '/sos/setting',
        icon: <ManageAccountsIcon fontSize='small' />,
      },
      {
        id: 'SafeReachSetting',
        title: 'Safe Reach Setting',
        messageId: 'Safe Reach Setting',
        module: 'Setting',
        submodule: 'Safe Reach Setting',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/setting/safe-reach',
        icon: <ManageAccountsIcon fontSize='small' />,
      },
      {
        id: 'TripNotificationCutoffSetting',
        title: 'Trip Notifications Cut off Settings',
        messageId: 'Trip Notifications Cut off Settings',
        module: 'Setting',
        submodule: 'Trip Notifications Cut off Settings',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/setting/trip-notification-cutoff',
        icon: <ManageAccountsIcon fontSize='small' />,
      },
      {
        id: 'Push Notification',
        title: 'Push Notification',
        messageId: 'Push Notification',
        module: 'Setting',
        iconUrl: 'PushNotification',
        submodule: 'Push Notification',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        url: '/setting/push-notification',
        icon: <ManageAccountsIcon fontSize='small' />,
      },
      {
        id: 'complianceSetting',
        title: 'Compliance Setting',
        messageId: 'Compliance',
        module: 'Setting',
        submodule: 'Compliance Setting',
        iconUrl: 'ComplianceSetting',
        permittedRole: RoutePermittedRole.ALL,
        type: 'item',
        icon: (
          <img
            className='sidebar-icon'
            src={'/assets/images/specialEmployee.svg'}
          />
        ),
        url: '/compliance/settings',
      },
    ],
  },
];
export default routesConfig;
